import React from "react";
import DefDateTime from "def-react-datetime";
import "def-react-datetime/css/def-react-datetime.css";
import "../../pages/Surveys/style.css";
import "./defaultV2.min.css";

import cogoToast from "cogo-toast";
import { Label, Input, Button, Card, CardBody, CardHeader, Container, Row, Col, Badge, Table } from "reactstrap";
import Form from "react-bootstrap/Form";
import { useState, useEffect, useMemo, useContext } from "react";
import { SUCCESS_RESULT } from "../../Constants";
import { FaTimes, FaCheck, FaArrowRight, FaArrowLeft, FaFilePdf, FaUsers, FaUserShield, FaEdit, FaClipboardList } from "react-icons/fa";
import { PulseLoader } from "react-spinners";
import * as Survey from "survey-react";
import { Link, useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { SurveyCreator, SurveyCreatorComponent } from "survey-creator-react";
import { StylesManager, Model, savePdf } from 'survey-core';
import { SurveyUI } from 'survey-react-ui';
import { SurveyPDF } from "survey-pdf";
import {
  initSurvey,
  updateQuestionnaire,
  onboardEnumerators,
  ListSurveyEnumerators,
  SaveSurveyManagers,
  getSurveyManagers,
  UpdateEnumeratorsStatus,
} from "../../services/Api";
import BtnSpinner from "../../components/BtnSpinner";

StylesManager.applyTheme("darkblue");

function createSurveyPdfModel(surveyModel, json) {
  let pdfWidth = !!surveyModel && surveyModel.pdfWidth ? surveyModel.pdfWidth : 210;
  let pdfHeight = !!surveyModel && surveyModel.pdfHeight ? surveyModel.pdfHeight : 297;
  let options = {
    haveCommercialLicense: true,
    fontSize: 14,
    margins: {
      left: 10,
      right: 10,
      top: 10,
      bot: 10
    },
    format: [pdfWidth, pdfHeight]
  };
  const surveyPDF = new SurveyPDF(json, options);
  return surveyPDF;
}

function saveSurveyToPdf(filename, surveyModel, surveyTemplateJson) {
  createSurveyPdfModel(surveyModel, surveyTemplateJson).save(filename);
}

const SurveyCreation = (props) => {
  const history = useHistory();
  const { _survey } = (props.location && props.location.state) || {};
  const [currentStep, setCurrentStep] = useState(1);
  const [surveyId, setSurveyId] = useState(null);
  const [surveyName, setSurveyName] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);

  const steps = [
    { id: 1, title: "Survey Details", icon: FaClipboardList },
    { id: 2, title: "Design Survey", icon: FaEdit },
    { id: 3, title: "Enumerators", icon: FaUsers },
    { id: 4, title: "Managers", icon: FaUserShield },
  ];

  useEffect(() => {
    // Initialize from localStorage or props
    const savedSurveyId = localStorage.getItem("current_survey_id");
    const savedSurveyName = localStorage.getItem("current_survey_name");
    
    if (_survey) {
      window._survey = _survey;
      localStorage.setItem("survey-design", _survey?.questionnaire || "");
      // Check for both id and survey_id (API might use either)
      const id = _survey.id || _survey.survey_id;
      if (id) {
        setSurveyId(id);
        setSurveyName(_survey.name || "");
        localStorage.setItem("current_survey_id", id);
        localStorage.setItem("current_survey_name", _survey.name || "");
        setIsInitialized(true);
      }
    } else if (savedSurveyId && savedSurveyId !== "null" && savedSurveyId !== "") {
      setSurveyId(savedSurveyId);
      setSurveyName(savedSurveyName || "");
      setIsInitialized(true);
    }
  }, []);

  const handleSurveySaved = (id, name) => {
    setSurveyId(id);
    setSurveyName(name);
    localStorage.setItem("current_survey_id", id);
    localStorage.setItem("current_survey_name", name);
    setIsInitialized(true);
    if (currentStep === 1) {
      setCurrentStep(2);
    }
  };

  const canNavigateToStep = (step) => {
    if (step === 1) return true;
    return isInitialized && surveyId;
  };

  const handleStepChange = (step) => {
    if (canNavigateToStep(step)) {
      setCurrentStep(step);
    } else {
      cogoToast.warn("Please complete Survey Details first", { hideAfter: 3 });
    }
  };

  const getStepStatus = (step) => {
    if (step < currentStep) return "completed";
    if (step === currentStep) return "active";
    return "pending";
  };

  return (
    <Container fluid style={{ padding: "20px" }}>
      {/* Header */}
      <Row className="mb-4">
        <Col>
          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
            <Link
              to="/ebms/surveys/list"
              style={{
                color: "#667eea",
                textDecoration: "none",
                fontWeight: "500",
              }}
            >
              Surveys
            </Link>
            <span style={{ color: "#999" }}>→</span>
            <span style={{ fontWeight: "600", color: "#333" }}>
              {surveyName || "New Survey"}
            </span>
          </div>
          <h2 style={{ margin: 0, color: "#333" }}>Create Survey</h2>
          <p style={{ color: "#666", marginTop: "5px" }}>
            Follow the steps below to create and configure your survey
          </p>
        </Col>
      </Row>

      {/* Progress Steps */}
      <Card className="shadow-sm mb-4">
        <CardBody>
          <Row>
            {steps.map((step, index) => {
              const StepIcon = step.icon;
              const status = getStepStatus(step.id);
              const isClickable = canNavigateToStep(step.id);
              
              return (
                <Col key={step.id} md={3} className="text-center">
                  <div
                    onClick={() => isClickable && handleStepChange(step.id)}
                    style={{
                      cursor: isClickable ? "pointer" : "not-allowed",
                      opacity: isClickable ? 1 : 0.6,
                      padding: "15px",
                      borderRadius: "8px",
                      transition: "all 0.3s",
                      background: status === "active" 
                        ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" 
                        : status === "completed"
                        ? "#e8f5e9"
                        : "#f5f5f5",
                    }}
                    onMouseEnter={(e) => {
                      if (isClickable && status !== "active") {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (isClickable && status !== "active") {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "none";
                      }
                    }}
                  >
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        background: status === "active"
                          ? "#fff"
                          : status === "completed"
                          ? "#4caf50"
                          : "#ccc",
                        color: status === "active" ? "#667eea" : status === "completed" ? "#fff" : "#999",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 10px",
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                      {status === "completed" ? (
                        <FaCheck />
                      ) : (
                        <StepIcon />
                      )}
                    </div>
                    <div
                      style={{
                        fontWeight: status === "active" ? "600" : "500",
                        color: status === "active" ? "#fff" : status === "completed" ? "#2e7d32" : "#666",
                        fontSize: "14px",
                      }}
                    >
                      {step.title}
                    </div>
                    {index < steps.length - 1 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "-50%",
                          width: "100%",
                          height: "2px",
                          background: status === "completed" ? "#4caf50" : "#e0e0e0",
                          zIndex: 0,
                        }}
                      />
                    )}
                  </div>
                </Col>
              );
            })}
          </Row>
        </CardBody>
      </Card>

      {/* Step Content */}
      <Card className="shadow-sm">
        <CardBody style={{ minHeight: "500px", padding: "30px" }}>
          {currentStep === 1 && (
            <SurveyDetails
              survey={_survey}
              onSave={handleSurveySaved}
              surveyId={surveyId || _survey?.id || _survey?.survey_id}
            />
          )}
          {currentStep === 2 && (
            <DesignSurvey
              surveyId={surveyId || _survey?.id || _survey?.survey_id || localStorage.getItem("current_survey_id")}
              onNext={() => handleStepChange(3)}
            />
          )}
          {currentStep === 3 && (
            <Enumerators
              surveyId={surveyId || _survey?.id || _survey?.survey_id || localStorage.getItem("current_survey_id")}
              onNext={() => handleStepChange(4)}
            />
          )}
          {currentStep === 4 && (
            <SurveyManagers surveyId={surveyId || _survey?.id || _survey?.survey_id || localStorage.getItem("current_survey_id")} />
          )}
        </CardBody>
      </Card>
    </Container>
  );
};

const SurveyDetails = ({ survey, onSave, surveyId: propSurveyId }) => {
  const [is_processing, setProcessing] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    location: "",
    start_date: "",
    end_date: "",
    description: "",
  });

  // Get surveyId from prop, survey object, or localStorage
  const currentSurveyId = propSurveyId || survey?.id || survey?.survey_id || localStorage.getItem("current_survey_id");

  useEffect(() => {
    if (survey) {
      setFormData({
        name: survey?.name || "",
        location: survey?.location || "",
        start_date: survey?.startdate || survey?.start_date || "",
        end_date: survey?.enddate || survey?.end_date || "",
        description: survey?.description || "",
      });
    }
  }, [survey]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name || formData.name.trim() === "") {
      cogoToast.error("Survey name is required", { hideAfter: 3 });
      return;
    }

    if (!formData.start_date || !formData.end_date) {
      cogoToast.error("Start date and end date are required", { hideAfter: 3 });
      return;
    }

    if (new Date(formData.start_date) > new Date(formData.end_date)) {
      cogoToast.error("End date must be after start date", { hideAfter: 3 });
      return;
    }

    // Use currentSurveyId which can come from prop, survey object, or localStorage
    const data = currentSurveyId && currentSurveyId !== "null" && currentSurveyId !== ""
      ? {
          survey_id: currentSurveyId,
          name: formData.name.trim(),
          description: formData.description.trim(),
          location: formData.location.trim(),
          start_date: formData.start_date,
          end_date: formData.end_date,
        }
      : {
          name: formData.name.trim(),
          description: formData.description.trim(),
          location: formData.location.trim(),
          start_date: formData.start_date,
          end_date: formData.end_date,
        };

    setProcessing(true);
    initSurvey(data)
      .then((res) => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            // If updating, use existing ID; if creating, use new ID from response
            const savedId = currentSurveyId && currentSurveyId !== "null" && currentSurveyId !== "" 
              ? currentSurveyId 
              : response.data;
            localStorage.setItem("current_survey_id", savedId);
            localStorage.setItem("current_survey_name", formData.name.trim());
            onSave(savedId, formData.name.trim());
            cogoToast.success(response.message || "Survey details saved successfully", {
              hideAfter: 5,
            });
          } else {
            cogoToast.error(response.message || "Failed to save survey details", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to save survey details", {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.error(err);
        cogoToast.error("Something went wrong, please try again.", {
          hideAfter: 5,
        });
      });
  };

  return (
    <div>
      <h3 style={{ marginBottom: "25px", color: "#333" }}>Survey Details</h3>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={6}>
            <Label for="name" style={{ fontWeight: "500", marginBottom: "8px" }}>
              Survey Name <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              type="text"
              id="name"
              required
              placeholder="Enter survey name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              style={{ marginBottom: "20px" }}
            />
          </Col>
          <Col md={6}>
            <Label for="location" style={{ fontWeight: "500", marginBottom: "8px" }}>
              Location <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              type="text"
              id="location"
              required
              placeholder="Enter location"
              value={formData.location}
              onChange={(e) => setFormData({ ...formData, location: e.target.value })}
              style={{ marginBottom: "20px" }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Label for="start_date" style={{ fontWeight: "500", marginBottom: "8px" }}>
              Start Date <span style={{ color: "red" }}>*</span>
            </Label>
            <DefDateTime
              dateFormat="yyyy-MM-DD"
              timeFormat={false}
              id="start_date"
              position="bottom"
              closeOnSelect={true}
              value={formData.start_date}
              onChange={(val) => setFormData({ ...formData, start_date: val })}
            />
          </Col>
          <Col md={6}>
            <Label for="end_date" style={{ fontWeight: "500", marginBottom: "8px" }}>
              End Date <span style={{ color: "red" }}>*</span>
            </Label>
            <DefDateTime
              dateFormat="yyyy-MM-DD"
              timeFormat={false}
              id="end_date"
              position="top"
              closeOnSelect={true}
              value={formData.end_date}
              onChange={(val) => setFormData({ ...formData, end_date: val })}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Label for="description" style={{ fontWeight: "500", marginBottom: "8px" }}>
              Description
            </Label>
            <Input
              type="textarea"
              id="description"
              rows="5"
              placeholder="Enter survey description"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              style={{ marginBottom: "20px" }}
            />
          </Col>
        </Row>
        <div style={{ marginTop: "30px", display: "flex", justifyContent: "flex-end" }}>
          <Button
            type="submit"
            color="primary"
            disabled={is_processing}
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              border: "none",
              padding: "10px 30px",
              fontWeight: "600",
            }}
          >
            {is_processing ? (
              <>
                <BtnSpinner loading={true} /> Processing...
              </>
            ) : (
              <>
                Save & Continue <FaArrowRight style={{ marginLeft: "8px" }} />
              </>
            )}
          </Button>
        </div>
      </Form>
    </div>
  );
};

const DesignSurvey = ({ surveyId, onNext }) => {
  const [is_processing, setProcessing] = useState(false);
  const [aceLoaded, setAceLoaded] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const checkAceLoaded = () => {
      try {
        return typeof window !== 'undefined' &&
          window.ace &&
          typeof window.ace.edit === 'function' &&
          typeof window.ace.require === 'function';
      } catch (e) {
        return false;
      }
    };

    if (checkAceLoaded()) {
      setAceLoaded(true);
      setIsReady(true);
      return;
    }

    let checkCount = 0;
    const maxChecks = 50;

    const checkAce = setInterval(() => {
      checkCount++;
      if (checkAceLoaded()) {
        setAceLoaded(true);
        setIsReady(true);
        clearInterval(checkAce);
      } else if (checkCount >= maxChecks) {
        setAceLoaded(false);
        setIsReady(true);
        clearInterval(checkAce);
      }
    }, 100);

    return () => {
      clearInterval(checkAce);
    };
  }, []);

  const creatorOptions = useMemo(() => ({
    showLogicTab: true,
    haveCommercialLicense: true,
    showJSONEditorTab: false,
    showTestSurveyTab: true,
    showEmbededSurveyTab: false,
    showTranslationTab: true,
  }), []);

  const creator = useMemo(() => {
    if (!isReady) {
      return null;
    }
    try {
      return new SurveyCreator(creatorOptions);
    } catch (error) {
      console.error('Error creating SurveyCreator:', error);
      return null;
    }
  }, [isReady, creatorOptions]);

  const saveQuestionnaire = (survey) => {
    // Get surveyId from prop or localStorage as fallback
    const currentSurveyId = surveyId || localStorage.getItem("current_survey_id");
    
    if (!currentSurveyId || currentSurveyId === "null" || currentSurveyId === "") {
      cogoToast.error("Survey ID is missing. Please save survey details first.", {
        hideAfter: 5,
      });
      return;
    }

    localStorage.setItem("survey-design", JSON.stringify(survey));
    const data = {
      survey_id: currentSurveyId,
      questionnaire: JSON.stringify(survey),
    };

    setProcessing(true);
    updateQuestionnaire(data)
      .then((res) => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            cogoToast.success(response.message || "Questionnaire saved successfully", {
              hideAfter: 5,
            });
            if (onNext) {
              setTimeout(() => onNext(), 500);
            }
          } else {
            cogoToast.error(response.message || "Failed to save questionnaire", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to save questionnaire", {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.error(err);
        cogoToast.error("Something went wrong, please try again.", {
          hideAfter: 5,
        });
      });
  };

  useEffect(() => {
    if (creator) {
      try {
        const savedDesign = localStorage.getItem("survey-design");
        if (savedDesign) {
          creator.text = savedDesign;
        }
      } catch (error) {
        console.error('Error setting survey design:', error);
      }
    }
  }, [creator]);

  if (!isReady) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <PulseLoader color="#667eea" />
        <p style={{ marginTop: "20px", color: "#666" }}>Loading survey editor...</p>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <h3 style={{ margin: 0, color: "#333" }}>Design Survey</h3>
        <Button
          color="info"
          onClick={() => {
            if (!creator) {
              cogoToast.error("Survey editor is still loading. Please wait...", {});
              return;
            }
            saveSurveyToPdf("Questionnaire.pdf", creator.JSON, creator.JSON);
          }}
          disabled={!creator}
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          <FaFilePdf /> Export to PDF
        </Button>
      </div>

      {isReady && creator ? (
        <SurveyCreatorComponent
          showEmbededSurveyTab={false}
          creator={creator}
        />
      ) : (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <PulseLoader color="#667eea" />
          <p style={{ marginTop: "20px", color: "#666" }}>Loading survey editor...</p>
        </div>
      )}

      <div style={{ marginTop: "30px", display: "flex", justifyContent: "flex-end" }}>
        <Button
          color="primary"
          disabled={!creator || is_processing}
          onClick={() => {
            if (!creator) {
              cogoToast.error("Survey editor is still loading. Please wait...", {});
              return;
            }
            saveQuestionnaire(creator.JSON);
          }}
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            border: "none",
            padding: "10px 30px",
            fontWeight: "600",
          }}
        >
          {is_processing ? (
            <>
              <BtnSpinner loading={true} /> Processing...
            </>
          ) : (
            <>
              Save & Continue <FaArrowRight style={{ marginLeft: "8px" }} />
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

const Enumerators = ({ surveyId, onNext }) => {
  const template = {
    logoPosition: "right",
    pages: [
      {
        name: "page1",
        elements: [
          {
            type: "matrixdynamic",
            name: "enumerators",
            isRequired: true,
            title: "Enter enumerators",
            columns: [
              { name: "name", title: "Name" },
              { name: "email", title: "Email" },
              { name: "phone", title: "Phone" },
            ],
            choices: [1, 2, 3, 4, 5],
            cellType: "text",
            rowCount: 1,
          },
        ],
      },
    ],
    showPrevButton: false,
    showCompletedPage: false,
    completeText: "Save & Next",
  };

  const [enumerators_list, setEnumerators_list] = useState([]);
  const [is_processing, setProcessing] = useState(false);
  const survey = useMemo(() => new Survey.Model(template), []);

  useEffect(() => {
    if (surveyId) {
      listEnumerators();
    }
  }, [surveyId]);

  const listEnumerators = () => {
    if (!surveyId) {
      return;
    }
    setProcessing(true);
    ListSurveyEnumerators({ survey_id: surveyId })
      .then((res) => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setEnumerators_list(response.data || []);
          } else {
            cogoToast.error(response.message || "Failed to load enumerators", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to load enumerators", {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.error(err);
        cogoToast.error("Something went wrong, please try again.", {
          hideAfter: 5,
        });
      });
  };

  survey.onComplete.add(function (sender) {
    const data = { ...sender.data, survey_id: surveyId };
    setProcessing(true);
    onboardEnumerators(data)
      .then((res) => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            listEnumerators();
            cogoToast.success(response.message || "Enumerators added successfully", {
              hideAfter: 5,
            });
            if (onNext) {
              setTimeout(() => onNext(), 500);
            }
          } else {
            cogoToast.error(response.message || "Failed to add enumerators", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to add enumerators", {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.error(err);
        cogoToast.error("Something went wrong, please try again.", {
          hideAfter: 5,
        });
      });
  });

  const updateEnums = () => {
    const activeStatus = document.getElementById("active_status")?.value;
    const liveStatus = document.getElementById("live_status")?.value;
    const checkboxes = document.getElementsByName("user_id");
    const selectedUsers = [];

    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        selectedUsers.push({
          enumerator_id: checkboxes[i].value,
          active_status: activeStatus,
          live_status: liveStatus,
        });
      }
    }

    if (!activeStatus || !liveStatus || selectedUsers.length < 1) {
      cogoToast.error("Please select enumerators and status", {
        hideAfter: 5,
      });
      return;
    }

    const data = {
      survey_id: surveyId,
      enumerators: selectedUsers,
    };

    setProcessing(true);
    UpdateEnumeratorsStatus(data)
      .then((res) => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            listEnumerators();
            cogoToast.success(response.message || "Enumerators updated successfully", {
              hideAfter: 5,
            });
          } else {
            cogoToast.error(response.message || "Failed to update enumerators", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to update enumerators", {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.error(err);
        cogoToast.error("Something went wrong, please try again.", {
          hideAfter: 5,
        });
      });
  };

  return (
    <div>
      <h3 style={{ marginBottom: "25px", color: "#333" }}>Survey Enumerators</h3>
      
      {template && <Survey.Survey model={survey} />}

      {is_processing && (
        <div className="text-center py-3">
          <BtnSpinner loading={true} />
        </div>
      )}

      {enumerators_list.length > 0 && (
        <div style={{ marginTop: "30px" }}>
          <h4 style={{ marginBottom: "20px", color: "#333" }}>Existing Enumerators</h4>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th style={{ width: "40px" }}></th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Mode</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {enumerators_list.map((e, index) => (
                <tr key={index}>
                  <td>
                    <Form.Check
                      name="user_id"
                      value={e.user_id}
                      className="m-0 align-middle"
                    />
                  </td>
                  <td>{e.name}</td>
                  <td>{e.email}</td>
                  <td>{e.phone}</td>
                  <td>
                    <Badge color={e.live_status == "10001" ? "success" : "warning"}>
                      {e.live_status == "10001" ? "Live" : "Training"}
                    </Badge>
                  </td>
                  <td>
                    <Badge color={e.active_status == "10001" ? "success" : "secondary"}>
                      {e.active_status == "10001" ? "Active" : "Inactive"}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Row style={{ marginTop: "20px" }}>
            <Col md={4}>
              <Input type="select" id="active_status">
                <option value="">Select Status</option>
                <option value={10001}>Active</option>
                <option value={10002}>Inactive</option>
              </Input>
            </Col>
            <Col md={4}>
              <Input type="select" id="live_status">
                <option value="">Select Mode</option>
                <option value={10001}>Live</option>
                <option value={10002}>Training</option>
              </Input>
            </Col>
            <Col md={4}>
              <Button
                color="primary"
                onClick={updateEnums}
                disabled={is_processing}
                block
              >
                Update Selected
              </Button>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

const SurveyManagers = ({ surveyId }) => {
  const [is_processing, setProcessing] = useState(false);
  const [managers, setManagers] = useState(null);
  const [user_and_rights, setUser_and_rights] = useState([]);

  useEffect(() => {
    if (surveyId) {
      getManagers();
    }
  }, [surveyId]);

  const _submit = (form_result) => {
    const payload = { ...form_result.valuesHash, survey_id: surveyId };
    setProcessing(true);
    SaveSurveyManagers(payload)
      .then((res) => {
        setProcessing(false);
        const response = res.data;
        if (res.status === 200) {
          if (response.status === SUCCESS_RESULT) {
            cogoToast.success("Survey Managers updated successfully", {
              hideAfter: 5,
            });
            getManagers();
          } else {
            cogoToast.error(response.message || "Failed to update managers", {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.error(err);
        cogoToast.error("Something went wrong, please try again.", {
          hideAfter: 5,
        });
      });
  };

  const getManagers = () => {
    if (!surveyId) {
      return;
    }
    setProcessing(true);
    getSurveyManagers({ survey_id: surveyId })
      .then((res) => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setManagers(response.data);
            const arr = [];
            response.data.managers?.map((d) => {
              arr.push({
                staff_email: d.manager_email,
                rights: JSON.parse(d.assigned_survey_rights),
              });
            });
            setUser_and_rights(arr);
          } else {
            cogoToast.error(response.message || "Failed to load managers", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to load managers", {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.error(err);
        cogoToast.error("Something went wrong, please try again.", {
          hideAfter: 5,
        });
      });
  };

  const survey = useMemo(() => {
    return managers?.template ? new Survey.Model(managers.template) : null;
  }, [managers]);

  useEffect(() => {
    if (survey) {
      survey.onComplete.add(function (sender) {
        _submit(sender);
      });
    }
  }, [survey]);

  return (
    <div>
      <h3 style={{ marginBottom: "25px", color: "#333" }}>Survey Managers</h3>

      {is_processing && (
        <div className="text-center py-3">
          <BtnSpinner loading={true} />
        </div>
      )}

      {managers?.managers && managers.managers.length > 0 && (
        <div style={{ marginBottom: "30px" }}>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Manager Name</th>
                <th>Email</th>
                <th>Permissions</th>
              </tr>
            </thead>
            <tbody>
              {managers.managers.map((e, index) => (
                <tr key={index}>
                  <td>{e.manager_name}</td>
                  <td>{e.manager_email}</td>
                  <td>
                    {JSON.parse(e.assigned_survey_rights)
                      .map((val) => val)
                      .join(", ")}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      {survey && (
        <div>
          <Button
            color="primary"
            onClick={(e) => {
              survey.data = { user_and_rights: user_and_rights };
            }}
            style={{ marginBottom: "20px" }}
          >
            Edit Managers
          </Button>
          <Survey.Survey model={survey} />
        </div>
      )}

      {!survey && !is_processing && (
        <div className="text-center py-5">
          <p className="text-muted">No manager template available</p>
        </div>
      )}
    </div>
  );
};

export default SurveyCreation;
